import Layout from '@/components/layout/Layout';
import { FC } from 'react';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import Pagination from '@/components/ui/pagination/Pagination';
import SectionTitle from '@/components/ui/section-title/SectionTitle';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { IPodcastData, IPodcastPage } from '@/interfaces/podcastsPage.interface';

interface IPodcastsProps {
  books: IPodcastPage;
}

const Podcasts: FC<IPodcastsProps> = ({ books }) => {
  const pagesCount = Math.ceil(books.total_count / BOOKS_FOR_PAGE);
  const currentPage = books.page;

  const SEO_TITLE = `Слушать подкасты онлайн бесплатно${currentPage > 1 ? ` - Cтраница ${currentPage}` : ``}`;
  const SEO_DESCRIPTION = `Слушать аудио подкасты онлайн. Большая база подкастов. Слушайте выпуски любимых подкастов на fantasy-worlds.ru`;
  const SEO_CANONICAL = `/lib/podcasts`;

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()}>
      <Breadcrumbs firstPageName="Подкасты" firstPageAlias="/podcasts" />
      <SectionTitle name="Аудио подкасты" />

      {books?.data && books?.data.length > 0 ? (
        books.data.map((book: IPodcastData) => (
          <BookCardItem
            id={book.id}
            author={{ first_name: book.authors[0].first_name, middle_name: book.authors[0].middle_name, last_name: book.authors[0].last_name, id: book.authors[0].id } as any}
            key={book.id}
            rating={book.rating}
            createdAt={book.created_at}
            title={book.title}
            description={book.description ? String(book.description) : ''}
            genres={book.genres}
            external_id={book.external_id}
            isPodcast
          />
        ))
      ) : (
        <div>Книги не найдены</div>
      )}

      <Pagination pagesCount={pagesCount ?? 0} postName={`lib/podcasts/pages/`} />
    </Layout>
  );
};

export default Podcasts;
